
import projectFlow from './project-flow';
import project from './project';

export default {
    path: 'tool',
    component: () => import(/*webpackChunkName: 'bidding-project'*/ '@layout/empty'),
    children: [
        projectFlow,
        project,
    ]
}